export default "__VITE_PUBLIC_ASSET__2edd92d4__"